(function () {
    "use strict";

    // @ngInject
    function NetworkFeedItemDirectiveControllerFunc(
            $scope, $state, $injector, NetworkManager, AnalyticsService, _,
            CompanyService, moment, AppStates, UIUtils) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkFeedItemDirectiveController';
        this.NetworkManager = NetworkManager;
        this.AnalyticsService = AnalyticsService;
        this._ = _;
        this.moment = moment;
        this.AppStates = AppStates;
        this.UIUtils = UIUtils;
        this.currUser = this.NetworkManager.getNetworkCurrUser();
        this.$state = $state;
        this.CompanyService = CompanyService;
        this.vendorTypeTranslationMap = this.CompanyService.getCompanyTypesTranslationMap();
        
        this.isShowingMoreText = false;
        this.maxShortTextLength = 200;
    }

    var NetworkFeedItemDirectiveController = Class(Controllers.BaseController, {
        constructor: NetworkFeedItemDirectiveControllerFunc,
        
        locationDisplayed: function locationDisplayed() {
            if (this.feedItem.activity.project.location) {
                return this.feedItem.activity.project.location.replace(', United States', '');
            }
            return '';
        },
        
        getImageStyle: function getImageStyle() {
            var cover_image = this.feedItem.activity.project.getCoverPhoto();

            if (cover_image) {
                return {'background-image': 'url(\"//res.cloudinary.com/honeybook/image/upload/h_190,w_280,c_lfill,dpr_auto/' + cover_image.cloudinary_public_id + '.jpg\")'};
            }
        },

        gotoUserProfile: function gotoUserProfile(event, user_id) {
            event.stopPropagation();
            event.preventDefault();
            this.goToState(this.AppStates.root_network_profile, {user_id: user_id});
        },
        
        getActivityAction: function getActivityAction() {
            var typeTxt = "";
            
            if (this.feedItem.activity.action_type) {
                var doneBy = this.feedItem.activity.done_by.full_name;
                if (this.feedItem.activity.action_type === "project_tag_vendor") {
                    doneBy = this.feedItem.activity.done_to.full_name;
                } else if(this.currUser._id === this.feedItem.activity.done_by._id){
                    doneBy = 'You';
                }
                if (this.feedItem.activity.action_type === "create_project") {
                    typeTxt = doneBy + " created a project";
                } else if (this.feedItem.activity.action_type === "project_comment") {
                    typeTxt = doneBy + " commented on a project";
                } else if (this.feedItem.activity.action_type === "project_tag_vendor") {
                    typeTxt = doneBy + " joined a project";
                } else if (this.feedItem.activity.action_type === "create_referral" || this.feedItem.activity.action_type === "referral_comment") {
                    typeTxt = 'Opportunity shared';
                }
            }

            return typeTxt;
        },
        
        getActivityTimestamp: function getActivityTimestamp() {
            var timeStampTxt = "";
            if (this.feedItem.activity.action_type === "create_referral" || this.feedItem.activity.action_type === "referral_comment") {
                timeStampTxt = this.moment(this.feedItem.activity.referral.created_at).fromNow();
            } else {
                timeStampTxt = this.moment(this.feedItem.activity.done_on).fromNow();
            }
            return timeStampTxt;
        },
        
        getActivityUser: function getActivityUser() {
            if (this.feedItem.activity.action_type && this.feedItem.activity.action_type === "project_tag_vendor") {
                var user = this.getUserById(this.feedItem.data.action_done_on_user, this.feedItem.activity.project.members);
                if (user) {
                    return user.network;
                }
            } else {
                return this.feedItem.activity.done_by.network;
            }

            return null;
        },
        
        getUserById: function getUserById(id, users) {
            for (var i = 0; i < users.length; i++) {
                if (users[i]._id === id) {
                    return users[i];
                }
            }
            return null;
        },
        
        shortText: function shortText(text) {
            return this.UIUtils.concatenateString(text, this.maxShortTextLength);
        },

        hasMoreText: function hasMoreText(text) {
            if (text && text.length) {
                return this.shortText(text).length < text.length;
            } else {
                return false;
            }
        },

        shortenedText: function shortenedText(text) {
            return (this.hasMoreText(text) && !this.isShowingMoreText) ? this.shortText(text) : text;
        },

        showMoreText: function showMoreText() {
            this.isShowingMoreText = true;
        },

        getVendorTypeDisplayed: function getVendorTypeDisplayed(type) {
            return this.vendorTypeTranslationMap[type];
        }
    });

    function NetworkFeedItemDirective() {
        return {
            scope: {
                feedItem: "=",
                currUser: "="
            },
            templateUrl: 'angular/app/modules/network/features/feed_item/network_feed_item_directive_template.html',
            controller: NetworkFeedItemDirectiveController,
            controllerAs: 'networkFeedItemVm',
            bindToController: true
        };
    };

    angular.module('honeybook.network.features.feed_item', [])
        .controller('NetworkFeedItemDirectiveController', NetworkFeedItemDirectiveController)
        .directive('hbNetworkFeedItem', NetworkFeedItemDirective);

}());
